import { useState } from "react";
import { Link } from "react-router-dom";
import { FaPlus } from "../../assets/icons/vander";
import { useSecretaryStore } from "../../hooks";
import { SecretaryLayout } from "../Layout";
import { ModalAddProcedureRoom, ProcedureRoomsTable } from "../components";

export const ProcedureRoomsPage = () => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  const [addProcedureRoom, setAddProcedureRoom] = useState(false);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <>
      <SecretaryLayout>
        <div className="container-fluid">
          <div className="layout-specing">
            <div className="row">
              <div className="col-xl-9 col-md-6">
                <h5 className="mb-0">Salas de procedimiento</h5>

                <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                  <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                    <li className="breadcrumb-item">
                      <Link to="/secretary/dashboard">gosafe</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Salas de procedimiento
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="col-xl-3 col-md-6 mt-4 mt-md-0 text-md-end">
                <button
                  className="btn btn-icon btn-pills btn-primary btn-lg"
                  onClick={() => setAddProcedureRoom(true)}
                >
                  <FaPlus className="icons" />
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-12 mt-4">
                <ProcedureRoomsTable />
              </div>
            </div>
          </div>
        </div>
      </SecretaryLayout>

      <ModalAddProcedureRoom
        addProcedureRoom={addProcedureRoom}
        setAddProcedureRoom={setAddProcedureRoom}
      />
    </>
  );
};
